// extracted by mini-css-extract-plugin
export var border = "snapshot-report-module--border--9e3f9";
export var shape = "snapshot-report-module--shape--c878c";
export var shape1 = "snapshot-report-module--shape-1--503b9";
export var shape2 = "snapshot-report-module--shape-2--8469d";
export var shape3 = "snapshot-report-module--shape-3--4a97b";